// Hindi strings for the field screens owned by fieldA: Scan home, Asset quick view, Sync status, offline queue messages,
// Location contents sheet, Guest loaners, scanned-tag landing page. Keyed by the English source text; {name} placeholders stay as-is.
export default {
  " (browser storage in use: {size})": " (ब्राउज़र स्टोरेज उपयोग में: {size})",
  " (Overdue {time})": " (देरी {time})",
  " A Repair Record was raised for the damaged item.": " क्षतिग्रस्त आइटम के लिए मरम्मत रिकॉर्ड बनाया गया।",
  " A replacement charge of {currency} {amount} was recorded.": " {currency} {amount} का प्रतिस्थापन शुल्क दर्ज किया गया।",
  " Ask a storekeeper or the onboarding team to bind it.": " इसे जोड़ने के लिए स्टोरकीपर या ऑनबोर्डिंग टीम से कहें।",
  " for {property}": " {property} के लिए",
  " · from offline data": " · ऑफ़लाइन डेटा से",
  "\"{code}\" is not in the data prepared for offline use. Check the code, or try again when you are back online.": "\"{code}\" ऑफ़लाइन उपयोग के लिए तैयार डेटा में नहीं है। कोड जाँचें, या ऑनलाइन होने पर फिर से कोशिश करें।",
  "(optional)": "(वैकल्पिक)",
  "({n} available)": "({n} उपलब्ध)",
  ", inactive": ", निष्क्रिय",
  "100% in good condition": "100% अच्छी स्थिति में",
  "A Repair Record (or a replacement charge for an unregistered item) will be raised automatically and the item withdrawn from the fleet.": "एक मरम्मत रिकॉर्ड (या अपंजीकृत आइटम के लिए प्रतिस्थापन शुल्क) अपने आप बनेगा और आइटम बेड़े से हटा दिया जाएगा।",
  "Across {n} guest room": "{n} अतिथि कमरे में",
  "Across {n} guest rooms": "{n} अतिथि कमरों में",
  "Actions": "कार्रवाइयाँ",
  "Actions taken offline wait here and sync in the order they were taken. Prepare for offline before a shift so rooms, count sheets and assets are on this device.": "ऑफ़लाइन किए गए कार्य यहाँ प्रतीक्षा करते हैं और उसी क्रम में सिंक होते हैं। शिफ्ट से पहले ऑफ़लाइन के लिए तैयार करें ताकि कमरे, गिनती शीट और एसेट इस डिवाइस पर हों।",
  "Active": "सक्रिय",
  "Active & Recent Guest Loans": "सक्रिय और हाल के अतिथि लोन",
  "Active On-Loan": "सक्रिय लोन पर",
  "All Statuses": "सभी स्थितियाँ",
  "Asset": "एसेट",
  "Asset quick view": "एसेट क्विक व्यू",
  "Asset quick view saved": "एसेट क्विक व्यू सहेजा गया",
  "Asset tag or short code": "एसेट टैग या शॉर्ट कोड",
  "Audit": "ऑडिट",
  "Audit checklists": "ऑडिट चेकलिस्ट",
  "Audit scan": "ऑडिट स्कैन",
  "Automated reminder notification sent to {room} supervisors for {item} ({n} recipient).": "{item} के लिए {room} के पर्यवेक्षकों को स्वचालित रिमाइंडर भेजा गया ({n} प्राप्तकर्ता)।",
  "Automated reminder notification sent to {room} supervisors for {item} ({n} recipients).": "{item} के लिए {room} के पर्यवेक्षकों को स्वचालित रिमाइंडर भेजा गया ({n} प्राप्तकर्ता)।",
  "Bind this tag to an asset": "इस टैग को एसेट से जोड़ें",
  "Blind count": "ब्लाइंड गिनती",
  "Camera preview": "कैमरा पूर्वावलोकन",
  "Camera unavailable": "कैमरा उपलब्ध नहीं",
  "Camera unavailable ({msg}). Type the code printed under the tag instead.": "कैमरा उपलब्ध नहीं ({msg})। इसके बजाय टैग के नीचे छपा कोड टाइप करें।",
  "Cancel": "रद्द करें",
  "Category": "श्रेणी",
  "Choose a location": "स्थान चुनें",
  "Choose a location to see what should be in it.": "देखने के लिए कि उसमें क्या होना चाहिए, एक स्थान चुनें।",
  "Choose a room, floor, wing or building…": "कमरा, मंज़िल, विंग या भवन चुनें…",
  "Choose where the asset is going.": "चुनें कि एसेट कहाँ जा रहा है।",
  "Close": "बंद करें",
  "Completed": "पूर्ण",
  "Condition": "स्थिति",
  "Condition now": "अभी की स्थिति",
  "Condition on return": "वापसी पर स्थिति",
  "Condition Rating *": "स्थिति रेटिंग *",
  "Condition: {condition}": "स्थिति: {condition}",
  "Confirm Issue & Dispatch": "जारी करने और भेजने की पुष्टि करें",
  "Confirm Return": "वापसी की पुष्टि करें",
  "Confirm return of": "वापसी की पुष्टि करें:",
  "Conflict": "टकराव",
  "Conflicts": "टकराव",
  "Connection": "कनेक्शन",
  "Could not read the selected photo": "चुनी गई फ़ोटो पढ़ी नहीं जा सकी",
  "Count sheets": "गिनती शीट",
  "Counted": "गिना गया",
  "Custodian": "संरक्षक",
  "Custody return": "कस्टडी वापसी",
  "Damage report": "क्षति रिपोर्ट",
  "Damage reported ({ref}) with a photo.": "फ़ोटो के साथ क्षति की रिपोर्ट की गई ({ref})।",
  "Damage reported for {tag} ({ref}).": "{tag} के लिए क्षति की रिपोर्ट की गई ({ref})।",
  "Damage reported for {tag}.": "{tag} के लिए क्षति की रिपोर्ट की गई।",
  "Damage reported with a photo.": "फ़ोटो के साथ क्षति की रिपोर्ट की गई।",
  "Damaged": "क्षतिग्रस्त",
  "Describe any damage": "किसी भी क्षति का वर्णन करें",
  "Describe the damage (at least 5 characters).": "क्षति का वर्णन करें (कम से कम 5 अक्षर)।",
  "Discard": "हटाएँ",
  "Dismiss": "खारिज करें",
  "Disposed": "निपटाया गया",
  "Download progress": "डाउनलोड प्रगति",
  "Downloading": "डाउनलोड हो रहा है",
  "Downloading the property and its locations": "प्रॉपर्टी और उसके स्थान डाउनलोड हो रहे हैं",
  "Downloading…": "डाउनलोड हो रहा है…",
  "Downloads your open and assigned audits with the expected contents of up to 300 rooms, the count sheets of your property's stock points, first-walk rooms and the quick-view details of every asset, so a full shift works without a connection.": "आपके खुले और सौंपे गए ऑडिट (300 कमरों तक की अपेक्षित सामग्री सहित), आपकी प्रॉपर्टी के स्टॉक पॉइंट की गिनती शीट, फर्स्ट-वॉक कमरे और हर एसेट का क्विक व्यू डाउनलोड करता है, ताकि पूरी शिफ्ट बिना कनेक्शन के चले।",
  "e.g. John Doe": "उदा. राहुल शर्मा",
  "e.g. RM-201 or AOS7K9": "उदा. RM-201 या AOS7K9",
  "e.g. Room 402": "उदा. कमरा 402",
  "Engineering": "इंजीनियरिंग",
  "Excellent": "उत्कृष्ट",
  "Expected Return": "अपेक्षित वापसी",
  "Expected Return Window *": "अपेक्षित वापसी अवधि *",
  "Export CSV": "CSV निर्यात करें",
  "Export XLSX": "XLSX निर्यात करें",
  "Exporting…": "निर्यात हो रहा है…",
  "Fair": "ठीक-ठाक",
  "Field app": "फ़ील्ड ऐप",
  "Filter by status": "स्थिति के अनुसार फ़िल्टर करें",
  "Find an asset": "एसेट खोजें",
  "First-walk exception": "फर्स्ट-वॉक अपवाद",
  "First-walk rooms": "फर्स्ट-वॉक कमरे",
  "Food & Beverage": "खाद्य एवं पेय",
  "Found in another room": "दूसरे कमरे में मिला",
  "from": "से",
  "Front Office": "फ्रंट ऑफ़िस",
  "Give a reason for the move (at least 3 characters).": "स्थानांतरण का कारण दें (कम से कम 3 अक्षर)।",
  "Good": "अच्छा",
  "Guest loaner issued successfully! {item} ({tag}) is out with {room}; return reminder scheduled for {when}.": "अतिथि लोनर सफलतापूर्वक जारी किया गया! {item} ({tag}) {room} के पास है; वापसी रिमाइंडर {when} के लिए निर्धारित है।",
  "Guest Loaners & Overdue Tracker": "अतिथि लोनर और देरी ट्रैकर",
  "Guest Name": "अतिथि का नाम",
  "Guest Room Number *": "अतिथि कमरा नंबर *",
  "Guest room number is required": "अतिथि कमरा नंबर आवश्यक है",
  "Guest Services": "अतिथि सेवाएँ",
  "has been printed but is not attached to an asset, location or Stock Point yet.": "प्रिंट हो चुका है लेकिन अभी किसी एसेट, स्थान या स्टॉक पॉइंट से नहीं जुड़ा है।",
  "Housekeeping": "हाउसकीपिंग",
  "How urgent?": "कितना ज़रूरी?",
  "In repair": "मरम्मत में",
  "In service": "सेवा में",
  "In store": "स्टोर में",
  "In transit": "रास्ते में",
  "Inactive": "निष्क्रिय",
  "Issue Guest Loaner Item": "अतिथि लोनर आइटम जारी करें",
  "Issue Loaner Item": "लोनर आइटम जारी करें",
  "Issued": "जारी किया गया",
  "IT & Telecom": "आईटी और टेलीकॉम",
  "Item": "आइटम",
  "Kit:": "किट:",
  "Last audit": "पिछला ऑडिट",
  "Last sync: {when}": "पिछला सिंक: {when}",
  "Last try: {error}": "पिछला प्रयास: {error}",
  "Loading contents…": "सामग्री लोड हो रही है…",
  "Loading guest loans...": "अतिथि लोन लोड हो रहे हैं...",
  "Loading property…": "प्रॉपर्टी लोड हो रही है…",
  "Loan Fleet Availability": "लोन बेड़े की उपलब्धता",
  "Loaned At": "लोन का समय",
  "Loaner Item": "लोनर आइटम",
  "Location": "स्थान",
  "Location Contents Sheet": "स्थान सामग्री शीट",
  "Locations saved": "स्थान सहेजे गए",
  "Look up": "खोजें",
  "Looking up the tag…": "टैग खोजा जा रहा है…",
  "Low (minor / scheduled)": "कम (मामूली / निर्धारित)",
  "Missing": "गायब",
  "More than one asset matches": "एक से अधिक एसेट मेल खाते हैं",
  "Move": "स्थानांतरित करें",
  "Move of {tag} to {place} recorded and sent for approval.": "{tag} का {place} में स्थानांतरण दर्ज किया गया और अनुमोदन के लिए भेजा गया।",
  "Move of {tag} to {place} recorded.": "{tag} का {place} में स्थानांतरण दर्ज किया गया।",
  "Needs your attention": "आपका ध्यान चाहिए",
  "Never": "कभी नहीं",
  "New": "नया",
  "Next": "अगला",
  "No conflicts. If the server refuses a synced action (for example the item was moved, the audit was completed or the count was already submitted), it appears here for you to retry, discard or open.": "कोई टकराव नहीं। अगर सर्वर किसी सिंक किए गए कार्य को अस्वीकार करता है (जैसे आइटम हटाया गया, ऑडिट पूरा हुआ या गिनती पहले ही जमा हुई), तो वह यहाँ दिखेगा ताकि आप फिर से कोशिश करें, हटाएँ या खोलें।",
  "No guest loans found.": "कोई अतिथि लोन नहीं मिला।",
  "No loaner items registered": "कोई लोनर आइटम पंजीकृत नहीं",
  "No locations are available offline. Prepare for offline on the Sync status page first.": "ऑफ़लाइन कोई स्थान उपलब्ध नहीं है। पहले सिंक स्थिति पेज पर ऑफ़लाइन के लिए तैयार करें।",
  "No pooled stock is held here.": "यहाँ कोई पूल्ड स्टॉक नहीं है।",
  "No returns yet today": "आज अभी तक कोई वापसी नहीं",
  "No tagged assets here. Stamp a kit to create the room's expected contents.": "यहाँ कोई टैग किए गए एसेट नहीं हैं। कमरे की अपेक्षित सामग्री बनाने के लिए किट स्टैम्प करें।",
  "No {item} is currently available": "अभी कोई {item} उपलब्ध नहीं है",
  "Normal": "सामान्य",
  "Not accepted": "स्वीकार नहीं",
  "Not assigned": "सौंपा नहीं गया",
  "Not audited yet": "अभी ऑडिट नहीं हुआ",
  "Notes": "नोट्स",
  "Nothing has been prepared on this device yet.": "इस डिवाइस पर अभी कुछ तैयार नहीं किया गया है।",
  "Nothing is waiting. Scans, counts, bindings and moves you make offline are kept here until they reach the server.": "कुछ भी प्रतीक्षा में नहीं है। ऑफ़लाइन किए गए स्कैन, गिनती, बाइंडिंग और स्थानांतरण सर्वर तक पहुँचने तक यहाँ रखे जाते हैं।",
  "Nothing overdue": "कुछ भी देरी में नहीं",
  "Nudge guests from the list below": "नीचे की सूची से अतिथियों को याद दिलाएँ",
  "Nudge Room": "कमरे को याद दिलाएँ",
  "Offline": "ऑफ़लाइन",
  "Offline - syncs automatically when back online": "ऑफ़लाइन - ऑनलाइन होने पर अपने आप सिंक होगा",
  "Offline: the damage report for {tag} is saved on this device and sent when you are back online (photos need a connection, so it is sent without one).": "ऑफ़लाइन: {tag} की क्षति रिपोर्ट इस डिवाइस पर सहेजी गई है और ऑनलाइन होने पर भेजी जाएगी (फ़ोटो के लिए कनेक्शन चाहिए, इसलिए यह बिना फ़ोटो के भेजी जाएगी)।",
  "Offline: the damage report for {tag} is saved on this device and sent when you are back online.": "ऑफ़लाइन: {tag} की क्षति रिपोर्ट इस डिवाइस पर सहेजी गई है और ऑनलाइन होने पर भेजी जाएगी।",
  "Offline: the move of {tag} is saved on this device and recorded when you are back online.": "ऑफ़लाइन: {tag} का स्थानांतरण इस डिवाइस पर सहेजा गया है और ऑनलाइन होने पर दर्ज होगा।",
  "Offline: the new condition of {tag} is saved on this device and recorded when you are back online.": "ऑफ़लाइन: {tag} की नई स्थिति इस डिवाइस पर सहेजी गई है और ऑनलाइन होने पर दर्ज होगी।",
  "Offline: the return of {tag} is saved on this device and recorded when you are back online.": "ऑफ़लाइन: {tag} की वापसी इस डिवाइस पर सहेजी गई है और ऑनलाइन होने पर दर्ज होगी।",
  "On hand": "उपलब्ध",
  "Online": "ऑनलाइन",
  "Open": "खोलें",
  "Open record": "रिकॉर्ड खोलें",
  "Open the first scan walk": "फर्स्ट स्कैन वॉक खोलें",
  "Open the full record": "पूरा रिकॉर्ड खोलें",
  "Open {asset}": "{asset} खोलें",
  "Opening the asset, location or Stock Point this label belongs to.": "यह लेबल जिस एसेट, स्थान या स्टॉक पॉइंट का है, उसे खोला जा रहा है।",
  "Or type the code (room code, asset tag or the short code under the barcode)": "या कोड टाइप करें (कमरा कोड, एसेट टैग या बारकोड के नीचे का शॉर्ट कोड)",
  "Out of service": "सेवा से बाहर",
  "Overdue": "देरी से",
  "Overdue Past Deadline": "समय सीमा से अधिक देरी",
  "Par": "पार",
  "Pending": "लंबित",
  "Photo": "फ़ोटो",
  "Photos must be JPEG, PNG or WebP images.": "फ़ोटो JPEG, PNG या WebP होनी चाहिए।",
  "Photos need a connection; the report is saved without one and sent when you are back online.": "फ़ोटो के लिए कनेक्शन चाहिए; रिपोर्ट बिना फ़ोटो के सहेजी जाती है और ऑनलाइन होने पर भेजी जाती है।",
  "Point the camera at a room's door tag to start its audit, or at an asset's tag to see its status and act on it.": "कमरे का ऑडिट शुरू करने के लिए कैमरा उसके दरवाज़े के टैग पर करें, या एसेट की स्थिति देखने और कार्रवाई के लिए उसके टैग पर।",
  "Pooled stock ({n})": "पूल्ड स्टॉक ({n})",
  "Poor (damaged)": "खराब (क्षतिग्रस्त)",
  "Prepare for offline": "ऑफ़लाइन के लिए तैयार करें",
  "Prepared {when}": "तैयार किया गया {when}",
  "Preparing needs a connection.": "तैयारी के लिए कनेक्शन चाहिए।",
  "Previous": "पिछला",
  "Print": "प्रिंट करें",
  "Printed {when}": "प्रिंट किया गया {when}",
  "Property": "प्रॉपर्टी",
  "Quick Return": "त्वरित वापसी",
  "Reason": "कारण",
  "Reason for the move": "स्थानांतरण का कारण",
  "Receiving department": "प्राप्त करने वाला विभाग",
  "Recondition": "रीकंडीशन",
  "Record move": "स्थानांतरण दर्ज करें",
  "Record return": "वापसी दर्ज करें",
  "Refresh offline data": "ऑफ़लाइन डेटा रीफ़्रेश करें",
  "Report damage": "क्षति की रिपोर्ट करें",
  "Report issue": "समस्या की रिपोर्ट करें",
  "Reports": "रिपोर्ट",
  "Retired": "सेवानिवृत्त",
  "Retry": "फिर से कोशिश करें",
  "Return": "वापस करें",
  "Return from custody": "कस्टडी से वापसी",
  "Returned": "लौटाया गया",
  "Returned damaged": "क्षतिग्रस्त लौटा",
  "Returned Today": "आज लौटाए गए",
  "Room #": "कमरा #",
  "Room sign-off": "कमरा साइन-ऑफ़",
  "Save condition": "स्थिति सहेजें",
  "Saved for offline use - details may have changed since.": "ऑफ़लाइन उपयोग के लिए सहेजा गया - विवरण तब से बदल सकते हैं।",
  "Scan": "स्कैन",
  "Scan a room or asset tag. A room offers its audit; an asset opens its quick view. Works offline once the shift is prepared.": "कमरे या एसेट का टैग स्कैन करें। कमरा उसका ऑडिट देता है; एसेट उसका क्विक व्यू खोलता है। शिफ्ट तैयार होने के बाद ऑफ़लाइन भी चलता है।",
  "Scan a tag or type the code printed under it.": "टैग स्कैन करें या उसके नीचे छपा कोड टाइप करें।",
  "Scan an asset tag from Scan, or type its code below.": "स्कैन से एसेट टैग स्कैन करें, या नीचे उसका कोड टाइप करें।",
  "Scanned Tag": "स्कैन किया गया टैग",
  "Search loans": "लोन खोजें",
  "Search room, guest, item...": "कमरा, अतिथि, आइटम खोजें...",
  "Select an expected return window": "अपेक्षित वापसी अवधि चुनें",
  "Select Available Equipment *": "उपलब्ध उपकरण चुनें *",
  "Select item...": "आइटम चुनें...",
  "Select the equipment to issue": "जारी करने के लिए उपकरण चुनें",
  "Send damage report": "क्षति रिपोर्ट भेजें",
  "Serial": "सीरियल",
  "Starting": "शुरू हो रहा है",
  "Status": "स्थिति",
  "Status, condition and last audit, with the actions you can take here. Actions work offline and sync later.": "स्थिति, हालत और पिछला ऑडिट, साथ में यहाँ की जा सकने वाली कार्रवाइयाँ। कार्रवाइयाँ ऑफ़लाइन चलती हैं और बाद में सिंक होती हैं।",
  "Stop": "रोकें",
  "Stored on this device: {size}": "इस डिवाइस पर संग्रहीत: {size}",
  "Storekeeper": "स्टोरकीपर",
  "Sync finished: {parts}.": "सिंक पूरा: {parts}।",
  "Sync now": "अभी सिंक करें",
  "Sync paused; it resumes automatically": "सिंक रुका है; यह अपने आप फिर शुरू होगा",
  "Sync status": "सिंक स्थिति",
  "Syncing…": "सिंक हो रहा है…",
  "Tag": "टैग",
  "Tag binding": "टैग बाइंडिंग",
  "Tag not bound yet": "टैग अभी जुड़ा नहीं है",
  "Tag {code} belongs to a stock point. Open Blind Counts to count it.": "टैग {code} एक स्टॉक पॉइंट का है। इसे गिनने के लिए ब्लाइंड काउंट खोलें।",
  "Tag {code} has been retired. Replace the label with a new tag.": "टैग {code} रिटायर हो चुका है। लेबल को नए टैग से बदलें।",
  "Tag {code} is no longer in use and cannot be bound again. Replace the label with a new tag.": "टैग {code} अब उपयोग में नहीं है और फिर से नहीं जोड़ा जा सकता। लेबल को नए टैग से बदलें।",
  "Tag {code} is not attached to an asset yet. Bind it during the first scan walk.": "टैग {code} अभी किसी एसेट से नहीं जुड़ा है। फर्स्ट स्कैन वॉक के दौरान इसे जोड़ें।",
  "Tag: {tag}": "टैग: {tag}",
  "Tagged assets ({n})": "टैग किए गए एसेट ({n})",
  "taken {when}": "किया गया {when}",
  "That tag is not attached to an asset.": "वह टैग किसी एसेट से नहीं जुड़ा है।",
  "The action was not accepted": "कार्रवाई स्वीकार नहीं हुई",
  "the asset it was on": "वह एसेट जिस पर यह था",
  "The download needs a connection. Try again when you are online.": "डाउनलोड के लिए कनेक्शन चाहिए। ऑनलाइन होने पर फिर कोशिश करें।",
  "The label may belong to another property, or the code was read incorrectly. Try typing the short code printed under the barcode.": "हो सकता है लेबल किसी दूसरी प्रॉपर्टी का हो, या कोड गलत पढ़ा गया हो। बारकोड के नीचे छपा शॉर्ट कोड टाइप करके देखें।",
  "the new location": "नया स्थान",
  "The record changed while you were offline": "आपके ऑफ़लाइन रहते रिकॉर्ड बदल गया",
  "The tag could not be looked up": "टैग खोजा नहीं जा सका",
  "This asset was not found, or it belongs to a property you cannot see.": "यह एसेट नहीं मिला, या यह ऐसी प्रॉपर्टी का है जिसे आप नहीं देख सकते।",
  "This browser cannot read tags with the camera. Type the code printed under the tag, or use a handheld scanner into the field below.": "यह ब्राउज़र कैमरे से टैग नहीं पढ़ सकता। टैग के नीचे छपा कोड टाइप करें, या नीचे के फ़ील्ड में हैंडहेल्ड स्कैनर का उपयोग करें।",
  "This property has no locations yet": "इस प्रॉपर्टी में अभी कोई स्थान नहीं है",
  "This tag has been retired": "यह टैग रिटायर हो चुका है",
  "To location": "स्थान तक",
  "Track loaner items issued to guest rooms and follow up on overdue returns.": "अतिथि कमरों को जारी लोनर आइटम ट्रैक करें और देर से हुई वापसी पर फ़ॉलो-अप करें।",
  "Urgent (guest-facing / safety)": "अत्यावश्यक (अतिथि से जुड़ा / सुरक्षा)",
  "Verified": "सत्यापित",
  "Waiting": "प्रतीक्षा में",
  "Waiting to sync": "सिंक की प्रतीक्षा में",
  "We could not find this tag": "हमें यह टैग नहीं मिला",
  "What is in a room right now: tagged assets one by one and pooled stock against par. Pick a floor or wing to print one sheet per room.": "अभी कमरे में क्या है: टैग किए गए एसेट एक-एक करके और पार के मुकाबले पूल्ड स्टॉक। हर कमरे की एक शीट प्रिंट करने के लिए मंज़िल या विंग चुनें।",
  "What is wrong?": "क्या खराबी है?",
  "Will retry": "फिर से कोशिश होगी",
  "Written off": "बट्टे खाते में",
  "You are offline and nothing has been prepared for offline use yet. Open Sync status and choose Prepare for offline before your next shift.": "आप ऑफ़लाइन हैं और ऑफ़लाइन उपयोग के लिए अभी कुछ तैयार नहीं है। अगली शिफ्ट से पहले सिंक स्थिति खोलें और ऑफ़लाइन के लिए तैयार करें चुनें।",
  "You are offline. Actions stay on this device and sync automatically when the connection returns.": "आप ऑफ़लाइन हैं। कार्य इस डिवाइस पर रहते हैं और कनेक्शन लौटने पर अपने आप सिंक होते हैं।",
  "Your role can view this asset but has no actions on it.": "आपकी भूमिका यह एसेट देख सकती है लेकिन इस पर कोई कार्रवाई नहीं कर सकती।",
  "Your role has no field actions for a room. Scan an asset tag to see the asset.": "आपकी भूमिका के पास कमरे के लिए कोई फ़ील्ड कार्रवाई नहीं है। एसेट देखने के लिए उसका टैग स्कैन करें।",
  "Your session has expired. Sign in again to sync; nothing on this device is lost.": "आपका सत्र समाप्त हो गया है। सिंक करने के लिए फिर से साइन इन करें; इस डिवाइस पर कुछ भी नहीं खोया है।",
  "{checklists} room checklists ({rooms} rooms, {batches} open audit)": "{checklists} कमरा चेकलिस्ट ({rooms} कमरे, {batches} खुला ऑडिट)",
  "{checklists} room checklists ({rooms} rooms, {batches} open audits)": "{checklists} कमरा चेकलिस्ट ({rooms} कमरे, {batches} खुले ऑडिट)",
  "{code} is a room, not an asset. Open it from Scan.": "{code} एक कमरा है, एसेट नहीं। इसे स्कैन से खोलें।",
  "{item} marked as Returned ({condition}) and restored to active housekeeping inventory.": "{item} को लौटाया गया ({condition}) चिह्नित किया गया और सक्रिय हाउसकीपिंग इन्वेंटरी में वापस रखा गया।",
  "{item} marked as Returned ({condition}) and withdrawn from the loaner fleet.": "{item} को लौटाया गया ({condition}) चिह्नित किया गया और लोनर बेड़े से हटा दिया गया।",
  "{n} assets for quick view": "क्विक व्यू के लिए {n} एसेट",
  "{n} conflict": "{n} टकराव",
  "{n} conflicts": "{n} टकराव",
  "{n} count sheets": "{n} गिनती शीट",
  "{n} first-walk rooms": "{n} फर्स्ट-वॉक कमरे",
  "{n} Item": "{n} आइटम",
  "{n} Items": "{n} आइटम",
  "{n} items could not be downloaded": "{n} आइटम डाउनलोड नहीं हो सके",
  "{n} loans": "{n} लोन",
  "{n} locations": "{n} स्थान",
  "{n} not accepted": "{n} स्वीकार नहीं",
  "{n} returned damaged": "{n} क्षतिग्रस्त लौटे",
  "{n} synced": "{n} सिंक हुए",
  "{pct}% in housekeeping store": "{pct}% हाउसकीपिंग स्टोर में",
  "{tag} is now graded {grade}.": "{tag} को अब {grade} ग्रेड दिया गया है।",
  "{tag} returned in {condition} condition.": "{tag} {condition} स्थिति में लौटाया गया।",
  "· {n} need attention": "· {n} पर ध्यान चाहिए",
  "· {n} waiting to sync": "· {n} सिंक होने की प्रतीक्षा में",
};
